export const useFakturoidStore = defineStore('fakturoid', {
  actions: {
    async fetchWorkspaceSettings(workspaceDomain) {
      const response = await useApi.get(`/workspaces/${workspaceDomain}/integrations/fakturoid`).catch((error) => {
        console.error(error);
        useToast.error(useT('fakturoid.workspace.fetchError'));
      });

      return response;
    },

    async saveWorkspaceSettings({ workspaceDomain, body }) {
      try {
        return await useApi.put(`/workspaces/${workspaceDomain}/integrations/fakturoid`, { body });
      } catch (error) {
        console.error(error);

        // 422/502 carry a specific message from the credentials check against Fakturoid.
        // error.data is a plain string here, but guard against a JSON { message } body too.
        const hasSpecificMessage = error.response?.status === 422 || error.response?.status === 502;
        useToast.error((hasSpecificMessage && (error.data?.message || error.data)) || useT('fakturoid.workspace.saveError'));
      }
    },

    // Returns undefined on failure — the event dialog falls back to a manual
    // account ID input instead of a toast.
    async fetchBankAccounts(workspaceDomain) {
      const response = await useApi.get(`/workspaces/${workspaceDomain}/integrations/fakturoid/bank-accounts`).catch((error) => {
        console.error(error);
      });

      return response;
    },

    async fetchEventTicketing({ eventId, workspaceDomain }) {
      const response = await useApi.get(`/events/${eventId}/fakturoid-ticketing`, {
        params: { workspaceDomain },
      }).catch((error) => {
        console.error(error);
        useToast.error(useT('fakturoid.workspace.fetchError'));
      });

      return response;
    },

    async saveEventTicketing({ eventId, body }) {
      const response = await useApi.put(`/events/${eventId}/fakturoid-ticketing`, {
        body,
      }).catch((error) => {
        console.error(error);
        useToast.error(useT('fakturoid.event.saveError'));
      });

      return response;
    },
  },
});
